import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { addSelectedActivity, editActivityItem, setActivityTiming, setApiIcreditGetURL, setCurrentStep, setLastOrderId, setOpportunity, setSelectedActivity } from "../../store/MahutiReducer";
import { ConnectToIcredit } from "../../utils/api";
import { FLOW_TYPE, PAGES, STEPS } from "../../utils/GlobalParams";
import { mySteps, nextBtnTextActivityFlow, nextBtnTextDateFlow } from "../../utils/stepperUtils";
import './StepperBtns.css'
const urlPrefix = process.env.REACT_APP_URL_PREFIX

export default function StepperBtns(props) {
    const store = useSelector(state => state.reducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();


    const nextBTNText = () => {
        if (location.pathname.includes("/activity")) return nextBtnTextActivityFlow;
        else return nextBtnTextDateFlow;
    }
    const handleOnPrevious = () => {
        if (store.currentStep > 0) {

            if (props.steps[store.currentStep].name === 'timeSelection') {
                // call set comp chain these
                dispatch(setActivityTiming(undefined));
            }

            if (props.steps[store.currentStep].name === 'activitySelection') {
                // call set comp chain these
                dispatch(setSelectedActivity(undefined));
            }
            dispatch(setCurrentStep(store.currentStep - 1));
        }
    }


    const handleOnNext = () => {
        if (props.steps.length - 1 === store.currentStep) {
            ConnectToIcredit(dispatch, navigate, store).then(res => {
                if (res.status === 200) {
                    dispatch(setApiIcreditGetURL(res.data));
                    console.log('my response in React', res.data);
                    let lpPrefix = store.lpName ? '/' + store.lpName : '';
                    navigate(urlPrefix + lpPrefix + '/' + PAGES.PAYMENT_PAGE)
                }
            });
        }
        if (props.steps[store.currentStep].name === 'timeSelection') {
            // call set comp chain these


        }
        if (store.currentStep + 1 < props.steps.length) {
            if (store.currentStep + 1 === props.steps.length - 1) {
                // on moving to last step

                const kidsTickets = store.visitors?.underAge || 0;
                const adults = store.visitors?.underAge || 0;
                if (store.activityEditMode) {
                    dispatch(editActivityItem({ ...store.selectedActivity, visitors: store.visitors, tickets: kidsTickets + adults, activityDate: store.activityDate }))
                }
            }

            dispatch(setCurrentStep(store.currentStep + 1));
        }
    }
    // disabled={props.steps[store.currentStep].disabled || store.errorMessageStep}
    const stepOneValidation = store.activityDate && (store.visitors?.adults || store.visitors?.underAge) ? true : false;
    const stepActivityValidation = store.selectedActivity ? true : false;
    const stepTimesValidation = store.selectedActivity && store.selectedActivity.timing ? true : false;

    const stepValidation = () => {
        if(store.flowType === FLOW_TYPE.DATE_FLOW) {

        }
        if(store.steps[store.currentStep]?.name === STEPS.DATE_SELECTION ) return stepOneValidation;
        if(store.steps[store.currentStep]?.name === STEPS.ACTIVITY_SELECTION) return stepActivityValidation;
        if(store.steps[store.currentStep]?.name === STEPS.TIME_SELECTION) return stepTimesValidation;
    }
    return <div id='stepperBtns' className="mt-lg-4 mt-0 pe-lg-4 pe-3 d-flex justify-content-end">
        {store.currentStep !== 0 ? (
            <button type="button" className="prev btn step_btn" onClick={handleOnPrevious}>הקודם</button>
        ) : ""}
        <button type="button" 
            tabIndex="0"
            className={"almoni_tzar_normal btn step_btn " + (!stepValidation() ? 'btn-disabled' : 'btn-primary')}
            aria-disabled={!stepValidation()}
            style={!stepValidation() ? { pointerEvents: 'auto' } : {}}
            onClick={(e) => !stepValidation() ? e.preventDefault() : handleOnNext()}
        >
            {nextBTNText()(store.currentStep)}
        </button>
    </div>
}